import * as React from 'react';
import { SVGProps } from 'react';

const GiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.88816 4.42784C7.26402 4.22085 6.85116 3.75572 6.65028 3.1129C6.61418 2.9975 6.49253 2.99876 6.49716 3.00036C6.42705 3.00036 6.36504 3.04593 6.34409 3.1128C6.14946 3.7341 5.74216 4.20944 5.10619 4.42719C4.96207 4.47655 4.96192 4.6813 5.10621 4.73071C5.73806 4.947 6.14801 5.4186 6.34428 6.04577C6.3805 6.16143 6.50193 6.15973 6.49766 6.15825C6.5679 6.15814 6.62988 6.11233 6.65064 6.04522C6.79579 5.57577 7.05185 5.2128 7.41172 4.9664L7.41175 4.96637C7.80518 4.69683 7.99833 4.77504 7.99805 4.57983C7.99798 4.51079 7.9537 4.44957 7.88816 4.42784Z"
      fill="#E78E08"
    />
    <path
      d="M5.74572 4.0796C5.74121 4.07805 5.73701 4.07591 5.73272 4.07397C5.54818 4.23253 5.33637 4.34831 5.10619 4.42714C4.96207 4.4765 4.96192 4.68125 5.10621 4.73066C5.73806 4.94695 6.14801 5.41854 6.34428 6.04571C6.3805 6.16137 6.50193 6.15968 6.49766 6.1582C6.72355 6.1578 6.6034 5.88799 6.97978 5.38264C6.77959 4.75406 6.36733 4.29239 5.74572 4.0796Z"
      fill="#FFAB2D"
    />
    <path
      d="M18.5547 11.5344H26.6764C27.7709 11.5251 28.6538 10.6378 28.6538 9.54719C28.6538 6.42317 24.9197 4.83344 22.6847 6.99622L18.5547 11.0007V11.5344Z"
      fill="#DE2236"
    />
    <path
      d="M18.5547 11.5344H26.6764C27.7709 11.5251 28.6538 10.6378 28.6538 9.54719C28.6538 6.42317 24.9197 4.83344 22.6847 6.99622L18.5547 11.0007V11.5344Z"
      fill="url(#paint0_linear_1875_52082)"
    />
    <path
      d="M18.5551 11.5344H10.4335C9.33899 11.5251 8.45605 10.6378 8.45605 9.54719C8.45605 6.42317 12.1902 4.83344 14.4251 6.99622L18.5551 11.0007V11.5344Z"
      fill="url(#paint1_linear_1875_52082)"
    />
    <path
      d="M18.5551 11.5344H10.4335C9.33899 11.5251 8.45605 10.6378 8.45605 9.54719C8.45605 6.42317 12.1902 4.83344 14.4251 6.99622L18.5551 11.0007V11.5344Z"
      fill="url(#paint2_linear_1875_52082)"
    />
    <path
      d="M18.5551 11.5344H10.4335C9.33899 11.5251 8.45605 10.6378 8.45605 9.54719C8.45605 6.42317 12.1902 4.83344 14.4251 6.99622L18.5551 11.0007V11.5344Z"
      fill="url(#paint3_radial_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint4_linear_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint5_linear_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint6_radial_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint7_linear_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint8_linear_1875_52082)"
    />
    <path
      d="M26.704 31.841H10.2952C9.21417 31.841 8.3457 30.983 8.3457 29.9152V17.9949H28.6534V29.9152C28.6534 30.974 27.785 31.841 26.704 31.841Z"
      fill="url(#paint9_linear_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint10_linear_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint11_linear_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint12_linear_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint13_radial_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint14_linear_1875_52082)"
    />
    <path
      d="M29.2645 11.5332H7.73549C7.0532 11.5332 6.5 12.0878 6.5 12.7719V16.7561C6.5 17.4401 7.0532 17.9947 7.73549 17.9947H29.2645C29.9468 17.9947 30.5 17.4401 30.5 16.7561V12.7719C30.5 12.0878 29.9468 11.5332 29.2645 11.5332Z"
      fill="url(#paint15_radial_1875_52082)"
    />
    <path
      d="M18.5042 6.91809C16.9714 6.91809 15.7305 8.18189 15.7305 9.74308V31.8412H21.2688V9.74308C21.278 8.18189 20.0371 6.91809 18.5042 6.91809Z"
      fill="url(#paint16_linear_1875_52082)"
    />
    <path
      d="M18.5042 6.91809C16.9714 6.91809 15.7305 8.18189 15.7305 9.74308V31.8412H21.2688V9.74308C21.278 8.18189 20.0371 6.91809 18.5042 6.91809Z"
      fill="url(#paint17_linear_1875_52082)"
    />
    <path
      d="M25.8945 6.91809C26.6157 7.1104 28.0176 7.95078 27.8561 9.77386"
      stroke="#FB5157"
      strokeWidth="0.461538"
      strokeLinecap="round"
    />
    <path
      d="M12.6543 6.76106C12.7972 6.74915 13.2187 6.84679 13.7617 7.33262C14.3047 7.81846 15.0835 8.63055 15.405 8.97587"
      stroke="#FB5157"
      strokeWidth="0.461538"
      strokeLinecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1875_52082"
        x1="24.6938"
        y1="11.9773"
        x2="24.6938"
        y2="10.2626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE280A" />
        <stop offset="1" stopColor="#CE280A" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1875_52082"
        x1="15.1205"
        y1="7.19047"
        x2="13.5056"
        y2="11.5344"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DF2332" />
        <stop offset="1" stopColor="#D9213B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1875_52082"
        x1="12.4161"
        y1="11.9773"
        x2="12.4161"
        y2="10.2626"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE280A" />
        <stop offset="1" stopColor="#CE280A" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_1875_52082"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.228 11.7987) rotate(-173.603) scale(2.37247 6.24007)"
      >
        <stop offset="0.150943" stopColor="#BD1123" />
        <stop offset="1" stopColor="#BD1123" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_1875_52082"
        x1="8.3457"
        y1="26.8218"
        x2="28.6534"
        y2="26.8218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1A738" />
        <stop offset="1" stopColor="#FAD42C" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_1875_52082"
        x1="18.4995"
        y1="16.1487"
        x2="18.4995"
        y2="19.1487"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C97525" />
        <stop offset="1" stopColor="#C97525" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint6_radial_1875_52082"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.3181 23.8218) rotate(180) scale(2.19231 17.25)"
      >
        <stop stopColor="#C87C28" />
        <stop offset="1" stopColor="#C87C28" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint7_linear_1875_52082"
        x1="7.83739"
        y1="24.9179"
        x2="10.8374"
        y2="24.9179"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2773F" />
        <stop offset="1" stopColor="#C2773F" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_1875_52082"
        x1="18.9731"
        y1="32.4121"
        x2="18.9731"
        y2="30.8419"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E68370" />
        <stop offset="1" stopColor="#E68370" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_1875_52082"
        x1="29.2989"
        y1="26.1295"
        x2="26.8181"
        y2="26.1295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF733" />
        <stop offset="1" stopColor="#FFF733" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_1875_52082"
        x1="30.5"
        y1="15.2135"
        x2="6.50016"
        y2="15.1516"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F6D729" />
        <stop offset="1" stopColor="#F39B3A" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_1875_52082"
        x1="30.5"
        y1="14.764"
        x2="28.9055"
        y2="14.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF850" />
        <stop offset="1" stopColor="#FFF850" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_1875_52082"
        x1="18.5"
        y1="18.2889"
        x2="18.5"
        y2="17.2038"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E8AF21" />
        <stop offset="1" stopColor="#E8AF21" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint13_radial_1875_52082"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(9.4103 18.6631) rotate(-90) scale(1.6838 12.0968)"
      >
        <stop stopColor="#DE7550" />
        <stop offset="1" stopColor="#DE7550" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint14_linear_1875_52082"
        x1="6.24082"
        y1="15.1542"
        x2="8.37483"
        y2="15.1542"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BE7841" />
        <stop offset="1" stopColor="#BE7841" stopOpacity="0" />
      </linearGradient>
      <radialGradient
        id="paint15_radial_1875_52082"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.607 15.7159) rotate(180) scale(2.33654 16.1826)"
      >
        <stop offset="0.188888" stopColor="#C57E10" />
        <stop offset="1" stopColor="#C57E10" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint16_linear_1875_52082"
        x1="18.5069"
        y1="6.91976"
        x2="18.5069"
        y2="31.8401"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D12136" />
        <stop offset="1" stopColor="#B6246E" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_1875_52082"
        x1="18.4997"
        y1="32.0767"
        x2="18.4997"
        y2="30.7435"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3368C" />
        <stop offset="1" stopColor="#B3368C" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default GiftIcon;
